/* @ngInject */

export default ($q, $rootScope, mergeService, fieldsService, helperService) => {
  /**
   * Get field name depending of the desired index.
   *
   * @param {String} name
   * @param {Number} index
   *
   * @returns {String}
   */
  const getFieldName = (name, index) => {
    const n = name.split(' - ');
    return n[index] !== '' ? n[index] : n[index - 1];
  };

  /**
   * Get field full name.
   *
   * @param {String} name
   *
   * @returns {String}
   */
  const getFieldFullName = (name) => {
    const n = name.split(' - ');
    return `${n[0]} - ${n[1]}`;
  };

  /**
   * Get available merge keys.
   *
   * @returns {Array}
   */
  const getAvailableMergeKeys = ({ model }) => {
    const deferred = $q.defer();
    mergeService.getAvailableKeys({ model }).then((keys) => {
      deferred.resolve(keys);
    });
    return deferred.promise;
  };

  /**
   * Get grouped merge fields.
   *
   * @returns {Array}
   */
  const getFields = (showMultipleData) => {
    const deferred = $q.defer();
    const fields = [];
    $q.all([
      getAvailableMergeKeys({ model: null }),
      fieldsService.getAvailable({ entity: 'ticket', isActive: true })
    ]).then((data) => {
      const contactsFields = _.filter(data[0], (d) => d?.groupName === 'CONTACT');
      const cLen = contactsFields.length;
      for (let c = 0; c < cLen; c += 1) {
        const contactsField = contactsFields[c];
        if (getFieldName(contactsField.name, 0) === 'Contact') {
          if (getFieldName(contactsField.name, 1) === 'Group Data') {
            if (_.findIndex(fields, { name: 'Contact - Group Data' }) === -1) {
              fields.push({
                name: getFieldFullName(contactsField.name),
                level: 0,
                weight: 'a01',
                icon: 'group',
                isOpen: true,
                value: [contactsField]
              });
            } else {
              const idx = _.findIndex(fields, { name: 'Contact - Group Data' });
              fields[idx].value.push(contactsField);
            }
          } else if (getFieldName(contactsField.name, 1) === 'Tables') {
            if (_.findIndex(fields, { name: 'Contact - Tables' }) === -1) {
              fields.push({
                name: getFieldFullName(contactsField.name),
                level: 0,
                weight: 'a01',
                icon: 'table_chart',
                isOpen: false,
                value: [contactsField]
              });
            } else {
              const idx = _.findIndex(fields, { name: 'Contact - Tables' });
              fields[idx].value.push(contactsField);
            }
          }
        } else if (getFieldName(contactsField.name, 0) === 'Contact 1') {
          if (getFieldName(contactsField.name, 1) === 'General Information') {
            if (_.findIndex(fields, { name: 'Contact 1 - General Information' }) === -1) {
              fields.push({
                name: getFieldFullName(contactsField.name),
                level: 0,
                weight: 'a02',
                icon: 'account_circle',
                isOpen: true,
                value: [contactsField]
              });
            } else {
              const idx = _.findIndex(fields, { name: 'Contact 1 - General Information' });
              fields[idx].value.push(contactsField);
            }
          } else if (getFieldName(contactsField.name, 1) === 'Additional General Information') {
            if (
              _.findIndex(fields, {
                name: 'Contact 1 - Additional General Information'
              }) === -1
            ) {
              fields.push({
                name: getFieldFullName(contactsField.name),
                level: 0,
                weight: 'a03',
                icon: 'account_box',
                isOpen: false,
                value: [contactsField]
              });
            } else {
              const idx = _.findIndex(fields, {
                name: 'Contact 1 - Additional General Information'
              });
              fields[idx].value.push(contactsField);
            }
          } else if (getFieldName(contactsField.name, 1) === 'Basic Contact Information') {
            if (_.findIndex(fields, { name: 'Contact 1 - Basic Contact Information' }) === -1) {
              fields.push({
                name: getFieldFullName(contactsField.name),
                level: 0,
                weight: 'a04',
                icon: 'phone',
                isOpen: false,
                value: [contactsField]
              });
            } else {
              const idx = _.findIndex(fields, {
                name: 'Contact 1 - Basic Contact Information'
              });
              fields[idx].value.push(contactsField);
            }
          } else if (getFieldName(contactsField.name, 1) === 'Additional Contact Information') {
            if (
              _.findIndex(fields, {
                name: 'Contact 1 - Additional Contact Information'
              }) === -1
            ) {
              fields.push({
                name: getFieldFullName(contactsField.name),
                level: 0,
                weight: 'a05',
                icon: 'contact_phone',
                isOpen: false,
                value: [contactsField]
              });
            } else {
              const idx = _.findIndex(fields, {
                name: 'Contact 1 - Additional Contact Information'
              });
              fields[idx].value.push(contactsField);
            }
          } else if (getFieldName(contactsField.name, 1) === 'Person Identification') {
            if (_.findIndex(fields, { name: 'Contact 1 - Person Identification' }) === -1) {
              fields.push({
                name: getFieldFullName(contactsField.name),
                level: 0,
                weight: 'a06',
                icon: 'perm_contact_calendar',
                isOpen: false,
                value: [contactsField]
              });
            } else {
              const idx = _.findIndex(fields, {
                name: 'Contact 1 - Person Identification'
              });
              fields[idx].value.push(contactsField);
            }
          } else if (getFieldName(contactsField.name, 1) === 'Family Relations') {
            if (_.findIndex(fields, { name: 'Contact 1 - Family Relations' }) === -1) {
              fields.push({
                name: getFieldFullName(contactsField.name),
                level: 0,
                weight: 'a07',
                icon: 'wc',
                isOpen: false,
                value: [contactsField]
              });
            } else {
              const idx = _.findIndex(fields, { name: 'Contact 1 - Family Relations' });
              fields[idx].value.push(contactsField);
            }
          } else if (
            getFieldName(contactsField.name, 1) === 'Company Director Or Beneficiary'
          ) {
            if (
              _.findIndex(fields, {
                name: 'Contact 1 - Company Director Or Beneficiary'
              }) === -1
            ) {
              fields.push({
                name: getFieldFullName(contactsField.name),
                level: 0,
                weight: 'a08',
                icon: 'person',
                isOpen: false,
                value: [contactsField]
              });
            } else {
              const idx = _.findIndex(fields, {
                name: 'Contact 1 - Company Director Or Beneficiary'
              });
              fields[idx].value.push(contactsField);
            }
          } else if (getFieldName(contactsField.name, 1) === 'Person Employment Details') {
            if (_.findIndex(fields, { name: 'Contact 1 - Person Employment Details' }) === -1) {
              fields.push({
                name: getFieldFullName(contactsField.name),
                level: 0,
                weight: 'a09',
                icon: 'work',
                isOpen: false,
                value: [contactsField]
              });
            } else {
              const orgCca2 = helperService.getOrganizationCountry().cca2;
              if (
                orgCca2 === 'NZ' &&
                (getFieldName(contactsField.name, 2) === 'Current Employment Class' ||
                  getFieldName(contactsField.name, 2) === 'Previous Employment Class')
              ) {
                const idx = _.findIndex(fields, {
                  name: 'Contact 1 - Person Employment Details'
                });
                fields[idx].value.push(contactsField);
              } else if (
                getFieldName(contactsField.name, 2) !== 'Current Employment Class' &&
                getFieldName(contactsField.name, 2) !== 'Previous Employment Class'
              ) {
                const idx = _.findIndex(fields, {
                  name: 'Contact 1 - Person Employment Details'
                });
                fields[idx].value.push(contactsField);
              }
            }
          }
        } else if (getFieldName(contactsField.name, 0) === 'Contact 2') {
          if (getFieldName(contactsField.name, 1) === 'General Information') {
            if (_.findIndex(fields, { name: 'Contact 2 - General Information' }) === -1) {
              fields.push({
                name: getFieldFullName(contactsField.name),
                level: 0,
                weight: 'b01',
                icon: 'account_circle',
                isOpen: true,
                value: [contactsField]
              });
            } else {
              const idx = _.findIndex(fields, { name: 'Contact 2 - General Information' });
              fields[idx].value.push(contactsField);
            }
          } else if (getFieldName(contactsField.name, 1) === 'Additional General Information') {
            if (
              _.findIndex(fields, {
                name: 'Contact 2 - Additional General Information'
              }) === -1
            ) {
              fields.push({
                name: getFieldFullName(contactsField.name),
                level: 0,
                weight: 'b02',
                icon: 'account_box',
                isOpen: false,
                value: [contactsField]
              });
            } else {
              const idx = _.findIndex(fields, {
                name: 'Contact 2 - Additional General Information'
              });
              fields[idx].value.push(contactsField);
            }
          } else if (getFieldName(contactsField.name, 1) === 'Basic Contact Information') {
            if (_.findIndex(fields, { name: 'Contact 2 - Basic Contact Information' }) === -1) {
              fields.push({
                name: getFieldFullName(contactsField.name),
                level: 0,
                weight: 'b03',
                icon: 'phone',
                isOpen: false,
                value: [contactsField]
              });
            } else {
              const idx = _.findIndex(fields, {
                name: 'Contact 2 - Basic Contact Information'
              });
              fields[idx].value.push(contactsField);
            }
          } else if (getFieldName(contactsField.name, 1) === 'Additional Contact Information') {
            if (
              _.findIndex(fields, {
                name: 'Contact 2 - Additional Contact Information'
              }) === -1
            ) {
              fields.push({
                name: getFieldFullName(contactsField.name),
                level: 0,
                weight: 'b04',
                icon: 'contact_phone',
                isOpen: false,
                value: [contactsField]
              });
            } else {
              const idx = _.findIndex(fields, {
                name: 'Contact 2 - Additional Contact Information'
              });
              fields[idx].value.push(contactsField);
            }
          } else if (getFieldName(contactsField.name, 1) === 'Person Identification') {
            if (_.findIndex(fields, { name: 'Contact 2 - Person Identification' }) === -1) {
              fields.push({
                name: getFieldFullName(contactsField.name),
                level: 0,
                weight: 'b05',
                icon: 'perm_contact_calendar',
                isOpen: false,
                value: [contactsField]
              });
            } else {
              const idx = _.findIndex(fields, {
                name: 'Contact 2 - Person Identification'
              });
              fields[idx].value.push(contactsField);
            }
          } else if (getFieldName(contactsField.name, 1) === 'Family Relations') {
            if (_.findIndex(fields, { name: 'Contact 2 - Family Relations' }) === -1) {
              fields.push({
                name: getFieldFullName(contactsField.name),
                level: 0,
                weight: 'b06',
                icon: 'wc',
                isOpen: false,
                value: [contactsField]
              });
            } else {
              const idx = _.findIndex(fields, { name: 'Contact 2 - Family Relations' });
              fields[idx].value.push(contactsField);
            }
          } else if (
            getFieldName(contactsField.name, 1) === 'Company Director Or Beneficiary'
          ) {
            if (
              _.findIndex(fields, {
                name: 'Contact 2 - Company Director Or Beneficiary'
              }) === -1
            ) {
              fields.push({
                name: getFieldFullName(contactsField.name),
                level: 0,
                weight: 'b07',
                icon: 'person',
                isOpen: false,
                value: [contactsField]
              });
            } else {
              const idx = _.findIndex(fields, {
                name: 'Contact 2 - Company Director Or Beneficiary'
              });
              fields[idx].value.push(contactsField);
            }
          } else if (getFieldName(contactsField.name, 1) === 'Person Employment Details') {
            if (_.findIndex(fields, { name: 'Contact 2 - Person Employment Details' }) === -1) {
              fields.push({
                name: getFieldFullName(contactsField.name),
                level: 0,
                weight: 'b08',
                icon: 'work',
                isOpen: false,
                value: [contactsField]
              });
            } else {
              const orgCca2 = helperService.getOrganizationCountry().cca2;
              if (
                orgCca2 === 'NZ' &&
                (getFieldName(contactsField.name, 2) === 'Current Employment Class' ||
                  getFieldName(contactsField.name, 2) === 'Previous Employment Class')
              ) {
                const idx = _.findIndex(fields, {
                  name: 'Contact 2 - Person Employment Details'
                });
                fields[idx].value.push(contactsField);
              } else if (
                getFieldName(contactsField.name, 2) !== 'Current Employment Class' &&
                getFieldName(contactsField.name, 2) !== 'Previous Employment Class'
              ) {
                const idx = _.findIndex(fields, {
                  name: 'Contact 2 - Person Employment Details'
                });
                fields[idx].value.push(contactsField);
              }
            }
          }
        } else if (getFieldName(contactsField.name, 0) === 'Contact 3') {
          if (getFieldName(contactsField.name, 1) === 'General Information') {
            if (_.findIndex(fields, { name: 'Contact 3 - General Information' }) === -1) {
              fields.push({
                name: getFieldFullName(contactsField.name),
                level: 0,
                weight: 'c01',
                icon: 'account_circle',
                isOpen: true,
                value: [contactsField]
              });
            } else {
              const idx = _.findIndex(fields, { name: 'Contact 3 - General Information' });
              fields[idx].value.push(contactsField);
            }
          } else if (getFieldName(contactsField.name, 1) === 'Additional General Information') {
            if (
              _.findIndex(fields, {
                name: 'Contact 3 - Additional General Information'
              }) === -1
            ) {
              fields.push({
                name: getFieldFullName(contactsField.name),
                level: 0,
                weight: 'c02',
                icon: 'account_box',
                isOpen: false,
                value: [contactsField]
              });
            } else {
              const idx = _.findIndex(fields, {
                name: 'Contact 3 - Additional General Information'
              });
              fields[idx].value.push(contactsField);
            }
          } else if (getFieldName(contactsField.name, 1) === 'Basic Contact Information') {
            if (_.findIndex(fields, { name: 'Contact 3 - Basic Contact Information' }) === -1) {
              fields.push({
                name: getFieldFullName(contactsField.name),
                level: 0,
                weight: 'c03',
                icon: 'phone',
                isOpen: false,
                value: [contactsField]
              });
            } else {
              const idx = _.findIndex(fields, {
                name: 'Contact 3 - Basic Contact Information'
              });
              fields[idx].value.push(contactsField);
            }
          } else if (getFieldName(contactsField.name, 1) === 'Additional Contact Information') {
            if (
              _.findIndex(fields, {
                name: 'Contact 3 - Additional Contact Information'
              }) === -1
            ) {
              fields.push({
                name: getFieldFullName(contactsField.name),
                level: 0,
                weight: 'c04',
                icon: 'contact_phone',
                isOpen: false,
                value: [contactsField]
              });
            } else {
              const idx = _.findIndex(fields, {
                name: 'Contact 3 - Additional Contact Information'
              });
              fields[idx].value.push(contactsField);
            }
          } else if (getFieldName(contactsField.name, 1) === 'Person Identification') {
            if (_.findIndex(fields, { name: 'Contact 3 - Person Identification' }) === -1) {
              fields.push({
                name: getFieldFullName(contactsField.name),
                level: 0,
                weight: 'c05',
                icon: 'perm_contact_calendar',
                isOpen: false,
                value: [contactsField]
              });
            } else {
              const idx = _.findIndex(fields, {
                name: 'Contact 3 - Person Identification'
              });
              fields[idx].value.push(contactsField);
            }
          } else if (getFieldName(contactsField.name, 1) === 'Family Relations') {
            if (_.findIndex(fields, { name: 'Contact 3 - Family Relations' }) === -1) {
              fields.push({
                name: getFieldFullName(contactsField.name),
                level: 0,
                weight: 'c06',
                icon: 'wc',
                isOpen: false,
                value: [contactsField]
              });
            } else {
              const idx = _.findIndex(fields, { name: 'Contact 3 - Family Relations' });
              fields[idx].value.push(contactsField);
            }
          } else if (
            getFieldName(contactsField.name, 1) === 'Company Director Or Beneficiary'
          ) {
            if (
              _.findIndex(fields, {
                name: 'Contact 3 - Company Director Or Beneficiary'
              }) === -1
            ) {
              fields.push({
                name: getFieldFullName(contactsField.name),
                level: 0,
                weight: 'c07',
                icon: 'person',
                isOpen: false,
                value: [contactsField]
              });
            } else {
              const idx = _.findIndex(fields, {
                name: 'Contact 3 - Company Director Or Beneficiary'
              });
              fields[idx].value.push(contactsField);
            }
          } else if (getFieldName(contactsField.name, 1) === 'Person Employment Details') {
            if (_.findIndex(fields, { name: 'Contact 3 - Person Employment Details' }) === -1) {
              fields.push({
                name: getFieldFullName(contactsField.name),
                level: 0,
                weight: 'c08',
                icon: 'work',
                isOpen: false,
                value: [contactsField]
              });
            } else {
              const orgCca2 = helperService.getOrganizationCountry().cca2;
              if (
                orgCca2 === 'NZ' &&
                (getFieldName(contactsField.name, 2) === 'Current Employment Class' ||
                  getFieldName(contactsField.name, 2) === 'Previous Employment Class')
              ) {
                const idx = _.findIndex(fields, {
                  name: 'Contact 3 - Person Employment Details'
                });
                fields[idx].value.push(contactsField);
              } else if (
                getFieldName(contactsField.name, 2) !== 'Current Employment Class' &&
                getFieldName(contactsField.name, 2) !== 'Previous Employment Class'
              ) {
                const idx = _.findIndex(fields, {
                  name: 'Contact 3 - Person Employment Details'
                });
                fields[idx].value.push(contactsField);
              }
            }
          }
        } else if (getFieldName(contactsField.name, 0) === 'Contact 4') {
          if (getFieldName(contactsField.name, 1) === 'General Information') {
            if (_.findIndex(fields, { name: 'Contact 4 - General Information' }) === -1) {
              fields.push({
                name: getFieldFullName(contactsField.name),
                level: 0,
                weight: 'd01',
                icon: 'account_circle',
                isOpen: true,
                value: [contactsField]
              });
            } else {
              const idx = _.findIndex(fields, { name: 'Contact 4 - General Information' });
              fields[idx].value.push(contactsField);
            }
          } else if (getFieldName(contactsField.name, 1) === 'Additional General Information') {
            if (
              _.findIndex(fields, {
                name: 'Contact 4 - Additional General Information'
              }) === -1
            ) {
              fields.push({
                name: getFieldFullName(contactsField.name),
                level: 0,
                weight: 'd02',
                icon: 'account_box',
                isOpen: false,
                value: [contactsField]
              });
            } else {
              const idx = _.findIndex(fields, {
                name: 'Contact 4 - Additional General Information'
              });
              fields[idx].value.push(contactsField);
            }
          } else if (getFieldName(contactsField.name, 1) === 'Basic Contact Information') {
            if (_.findIndex(fields, { name: 'Contact 4 - Basic Contact Information' }) === -1) {
              fields.push({
                name: getFieldFullName(contactsField.name),
                level: 0,
                weight: 'd03',
                icon: 'phone',
                isOpen: false,
                value: [contactsField]
              });
            } else {
              const idx = _.findIndex(fields, {
                name: 'Contact 4 - Basic Contact Information'
              });
              fields[idx].value.push(contactsField);
            }
          } else if (getFieldName(contactsField.name, 1) === 'Additional Contact Information') {
            if (
              _.findIndex(fields, {
                name: 'Contact 4 - Additional Contact Information'
              }) === -1
            ) {
              fields.push({
                name: getFieldFullName(contactsField.name),
                level: 0,
                weight: 'd04',
                icon: 'contact_phone',
                isOpen: false,
                value: [contactsField]
              });
            } else {
              const idx = _.findIndex(fields, {
                name: 'Contact 4 - Additional Contact Information'
              });
              fields[idx].value.push(contactsField);
            }
          } else if (getFieldName(contactsField.name, 1) === 'Person Identification') {
            if (_.findIndex(fields, { name: 'Contact 4 - Person Identification' }) === -1) {
              fields.push({
                name: getFieldFullName(contactsField.name),
                level: 0,
                weight: 'd05',
                icon: 'perm_contact_calendar',
                isOpen: false,
                value: [contactsField]
              });
            } else {
              const idx = _.findIndex(fields, {
                name: 'Contact 4 - Person Identification'
              });
              fields[idx].value.push(contactsField);
            }
          } else if (getFieldName(contactsField.name, 1) === 'Family Relations') {
            if (_.findIndex(fields, { name: 'Contact 4 - Family Relations' }) === -1) {
              fields.push({
                name: getFieldFullName(contactsField.name),
                level: 0,
                weight: 'd06',
                icon: 'wc',
                isOpen: false,
                value: [contactsField]
              });
            } else {
              const idx = _.findIndex(fields, { name: 'Contact 4 - Family Relations' });
              fields[idx].value.push(contactsField);
            }
          } else if (
            getFieldName(contactsField.name, 1) === 'Company Director Or Beneficiary'
          ) {
            if (
              _.findIndex(fields, {
                name: 'Contact 4 - Company Director Or Beneficiary'
              }) === -1
            ) {
              fields.push({
                name: getFieldFullName(contactsField.name),
                level: 0,
                weight: 'd07',
                icon: 'person',
                isOpen: false,
                value: [contactsField]
              });
            } else {
              const idx = _.findIndex(fields, {
                name: 'Contact 4 - Company Director Or Beneficiary'
              });
              fields[idx].value.push(contactsField);
            }
          } else if (getFieldName(contactsField.name, 1) === 'Person Employment Details') {
            if (_.findIndex(fields, { name: 'Contact 4 - Person Employment Details' }) === -1) {
              fields.push({
                name: getFieldFullName(contactsField.name),
                level: 0,
                weight: 'd08',
                icon: 'work',
                isOpen: false,
                value: [contactsField]
              });
            } else {
              const orgCca2 = helperService.getOrganizationCountry().cca2;
              if (
                orgCca2 === 'NZ' &&
                (getFieldName(contactsField.name, 2) === 'Current Employment Class' ||
                  getFieldName(contactsField.name, 2) === 'Previous Employment Class')
              ) {
                const idx = _.findIndex(fields, {
                  name: 'Contact 4 - Person Employment Details'
                });
                fields[idx].value.push(contactsField);
              } else if (
                getFieldName(contactsField.name, 2) !== 'Current Employment Class' &&
                getFieldName(contactsField.name, 2) !== 'Previous Employment Class'
              ) {
                const idx = _.findIndex(fields, {
                  name: 'Contact 4 - Person Employment Details'
                });
                fields[idx].value.push(contactsField);
              }
            }
          }
        }
      }

      const ticketsFields = _.filter(data[0], (d) => d?.groupName === 'TICKET');
      const tLen = ticketsFields.length;
      for (let t = 0; t < tLen; t += 1) {
        const ticketsField = ticketsFields[t];
        if (getFieldName(ticketsField.name, 1) === 'Aggregated Values') {
          if (_.findIndex(fields, { name: 'Deal - Aggregated Values' }) === -1) {
            fields.push({
              name: getFieldFullName(ticketsField.name),
              level: 0,
              weight: 'e01',
              icon: 'monetization_on',
              isOpen: true,
              value: [ticketsField]
            });
          } else {
            const idx = _.findIndex(fields, { name: 'Deal - Aggregated Values' });
            fields[idx].value.push(ticketsField);
          }
        } else if (getFieldName(ticketsField.name, 1) === 'General Information') {
          if (_.findIndex(fields, { name: 'Deal - General Information' }) === -1) {
            fields.push({
              name: getFieldFullName(ticketsField.name),
              level: 0,
              weight: 'e01',
              icon: 'monetization_on',
              isOpen: true,
              value: [ticketsField]
            });
          } else {
            const idx = _.findIndex(fields, { name: 'Deal - General Information' });
            fields[idx].value.push(ticketsField);
          }
        } else if (getFieldName(ticketsField.name, 1) === 'Status') {
          if (_.findIndex(fields, { name: 'Deal - Status' }) === -1) {
            fields.push({
              name: getFieldFullName(ticketsField.name),
              level: 0,
              weight: 'e02',
              icon: 'traffic',
              isOpen: false,
              value: [ticketsField]
            });
          } else {
            const idx = _.findIndex(fields, { name: 'Deal - Status' });
            fields[idx].value.push(ticketsField);
          }
        } else if (getFieldName(ticketsField.name, 1) === 'Owner') {
          if (_.findIndex(fields, { name: 'Deal - Owner' }) === -1) {
            fields.push({
              name: getFieldFullName(ticketsField.name),
              level: 0,
              weight: 'e03',
              icon: 'person',
              isOpen: false,
              value: [ticketsField]
            });
          } else {
            const idx = _.findIndex(fields, { name: 'Deal - Owner' });
            fields[idx].value.push(ticketsField);
          }
        } else if (getFieldName(ticketsField.name, 1) === 'Asset Finance') {
          if (_.findIndex(fields, { name: 'Deal - Asset Finance' }) === -1) {
            fields.push({
              name: getFieldFullName(ticketsField.name),
              level: 0,
              weight: 'e04',
              icon: 'account_circle',
              isOpen: false,
              workflowType: ['assetfinance'],
              value: [ticketsField]
            });
          } else {
            const idx = _.findIndex(fields, { name: 'Deal - Asset Finance' });
            fields[idx].value.push(ticketsField);
          }
        } else if (getFieldName(ticketsField.name, 1) === 'Insurance') {
          if (_.findIndex(fields, { name: 'Deal - Insurance' }) === -1) {
            fields.push({
              name: getFieldFullName(ticketsField.name),
              level: 0,
              weight: 'e05',
              icon: 'home',
              isOpen: false,
              workflowType: ['insurance'],
              value: [ticketsField]
            });
          } else {
            const idx = _.findIndex(fields, { name: 'Deal - Insurance' });
            fields[idx].value.push(ticketsField);
          }
        } else if (getFieldName(ticketsField.name, 1) === 'Home Loan Security') {
          if (_.findIndex(fields, { name: 'Deal - Home Loan Security' }) === -1) {
            fields.push({
              name: getFieldFullName(ticketsField.name),
              level: 0,
              weight: 'e06',
              icon: 'home',
              isOpen: false,
              workflowType: ['homeloan'],
              value: [ticketsField]
            });
          } else {
            const idx = _.findIndex(fields, { name: 'Deal - Home Loan Security' });
            fields[idx].value.push(ticketsField);
          }
        } else if (getFieldName(ticketsField.name, 1) === 'Home Loan Split') {
          if (_.findIndex(fields, { name: 'Deal - Home Loan Split' }) === -1) {
            fields.push({
              name: getFieldFullName(ticketsField.name),
              level: 0,
              weight: 'e07',
              icon: 'account_balance',
              isOpen: false,
              workflowType: ['homeloan'],
              value: [ticketsField]
            });
          } else {
            const idx = _.findIndex(fields, { name: 'Deal - Home Loan Split' });
            fields[idx].value.push(ticketsField);
          }
        } else if (getFieldName(ticketsField.name, 1) === 'Home Loan Fees') {
          if (_.findIndex(fields, { name: 'Deal - Home Loan Fees' }) === -1) {
            fields.push({
              name: getFieldFullName(ticketsField.name),
              level: 0,
              weight: 'e08',
              icon: 'monetization_on',
              isOpen: false,
              workflowType: ['homeloan'],
              value: [ticketsField]
            });
          } else {
            const idx = _.findIndex(fields, { name: 'Deal - Home Loan Fees' });
            fields[idx].value.push(ticketsField);
          }
        } else if (getFieldName(ticketsField.name, 1) === 'Income') {
          if (_.findIndex(fields, { name: 'Deal - Income' }) === -1) {
            fields.push({
              name: getFieldFullName(ticketsField.name),
              level: 0,
              weight: 'e10',
              icon: 'credit_card',
              isOpen: false,
              workflowType: [
                'assetfinance',
                'commercialloan',
                'conveyancing',
                'homeloan',
                'insurance',
                'personalloan'
              ],
              value: [ticketsField]
            });
          } else if (
            $rootScope.CurrentOrganization &&
            $rootScope.CurrentOrganization.organization &&
            $rootScope.CurrentOrganization.organization.location &&
            $rootScope.CurrentOrganization.organization.location.name &&
            $rootScope.CurrentOrganization.organization.location.name.common ===
              'New Zealand' &&
            getFieldName(ticketsField.name, 2).includes('Boarder Income')
          ) {
            const idx = _.findIndex(fields, { name: 'Deal - Income' });
            fields[idx].value.push(ticketsField);
          } else if (!getFieldName(ticketsField.name, 2).includes('Boarder Income')) {
            const idx = _.findIndex(fields, { name: 'Deal - Income' });
            fields[idx].value.push(ticketsField);
          }
        } else if (getFieldName(ticketsField.name, 1) === 'Commercial Loan Property Security') {
          if (
            _.findIndex(fields, { name: 'Deal - Commercial Loan Property Security' }) === -1
          ) {
            fields.push({
              name: getFieldFullName(ticketsField.name),
              level: 0,
              weight: 'e11',
              icon: 'credit_card',
              isOpen: false,
              workflowType: ['commercialloan'],
              value: [ticketsField]
            });
          } else {
            const idx = _.findIndex(fields, {
              name: 'Deal - Commercial Loan Property Security'
            });
            fields[idx].value.push(ticketsField);
          }
        } else if (
          getFieldName(ticketsField.name, 1) === 'Commercial Loan Cash Deposit Security'
        ) {
          if (
            _.findIndex(fields, {
              name: 'Deal - Commercial Loan Cash Deposit Security'
            }) === -1
          ) {
            fields.push({
              name: getFieldFullName(ticketsField.name),
              level: 0,
              weight: 'e12',
              icon: 'attach_money',
              isOpen: false,
              workflowType: ['commercialloan'],
              value: [ticketsField]
            });
          } else {
            const idx = _.findIndex(fields, {
              name: 'Deal - Commercial Loan Cash Deposit Security'
            });
            fields[idx].value.push(ticketsField);
          }
        } else if (
          getFieldName(ticketsField.name, 1) === 'Commercial Loan Investment Security'
        ) {
          if (
            _.findIndex(fields, { name: 'Deal - Commercial Loan Investment Security' }) === -1
          ) {
            fields.push({
              name: getFieldFullName(ticketsField.name),
              level: 0,
              weight: 'e13',
              icon: 'build',
              isOpen: false,
              workflowType: ['commercialloan'],
              value: [ticketsField]
            });
          } else {
            const idx = _.findIndex(fields, {
              name: 'Deal - Commercial Loan Investment Security'
            });
            fields[idx].value.push(ticketsField);
          }
        } else if (
          getFieldName(ticketsField.name, 1) === 'Commercial Loan Car Equipment Security'
        ) {
          if (
            _.findIndex(fields, {
              name: 'Deal - Commercial Loan Car Equipment Security'
            }) === -1
          ) {
            fields.push({
              name: getFieldFullName(ticketsField.name),
              level: 0,
              weight: 'e14',
              icon: 'directions_car',
              isOpen: false,
              workflowType: ['commercialloan'],
              value: [ticketsField]
            });
          } else {
            const idx = _.findIndex(fields, {
              name: 'Deal - Commercial Loan Car Equipment Security'
            });
            fields[idx].value.push(ticketsField);
          }
        } else if (getFieldName(ticketsField.name, 1) === 'Commercial Loan Other Security') {
          if (_.findIndex(fields, { name: 'Deal - Commercial Loan Other Security' }) === -1) {
            fields.push({
              name: getFieldFullName(ticketsField.name),
              level: 0,
              weight: 'e15',
              icon: 'work',
              isOpen: false,
              workflowType: ['commercialloan'],
              value: [ticketsField]
            });
          } else {
            const idx = _.findIndex(fields, {
              name: 'Deal - Commercial Loan Other Security'
            });
            fields[idx].value.push(ticketsField);
          }
        } else if (getFieldName(ticketsField.name, 1) === 'Commercial Loan Split') {
          if (_.findIndex(fields, { name: 'Deal - Commercial Loan Split' }) === -1) {
            fields.push({
              name: getFieldFullName(ticketsField.name),
              level: 0,
              weight: 'e16',
              icon: 'account_balance',
              isOpen: false,
              workflowType: ['commercialloan'],
              value: [ticketsField]
            });
          } else {
            const idx = _.findIndex(fields, { name: 'Deal - Commercial Loan Split' });
            fields[idx].value.push(ticketsField);
          }
        } else if (getFieldName(ticketsField.name, 1) === 'Commercial Loan Fees') {
          if (_.findIndex(fields, { name: 'Deal - Commercial Loan Fees' }) === -1) {
            fields.push({
              name: getFieldFullName(ticketsField.name),
              level: 0,
              weight: 'e17',
              icon: 'monetization_on',
              isOpen: false,
              workflowType: ['commercialloan'],
              value: [ticketsField]
            });
          } else {
            const idx = _.findIndex(fields, { name: 'Deal - Commercial Loan Fees' });
            fields[idx].value.push(ticketsField);
          }
        } else if (getFieldName(ticketsField.name, 1) === 'Personal Loan') {
          if (_.findIndex(fields, { name: 'Deal - Personal Loan' }) === -1) {
            fields.push({
              name: getFieldFullName(ticketsField.name),
              level: 0,
              weight: 'e18',
              icon: 'person',
              isOpen: false,
              workflowType: ['personalloan'],
              value: [ticketsField]
            });
          } else {
            const idx = _.findIndex(fields, { name: 'Deal - Personal Loan' });
            fields[idx].value.push(ticketsField);
          }
        } else if (getFieldName(ticketsField.name, 1) === 'Conveyancing Loan Security') {
          if (_.findIndex(fields, { name: 'Deal - Conveyancing Loan Security' }) === -1) {
            fields.push({
              name: getFieldFullName(ticketsField.name),
              level: 0,
              weight: 'e19',
              icon: 'security',
              isOpen: false,
              workflowType: ['conveyancing'],
              value: [ticketsField]
            });
          } else {
            const idx = _.findIndex(fields, { name: 'Deal - Conveyancing Loan Security' });
            fields[idx].value.push(ticketsField);
          }
        } else if (getFieldName(ticketsField.name, 1) === 'Conveyancing Loan Fees') {
          if (_.findIndex(fields, { name: 'Deal - Conveyancing Loan Fees' }) === -1) {
            fields.push({
              name: getFieldFullName(ticketsField.name),
              level: 0,
              weight: 'e20',
              icon: 'monetization_on',
              isOpen: false,
              workflowType: ['conveyancing'],
              value: [ticketsField]
            });
          } else {
            const idx = _.findIndex(fields, { name: 'Deal - Conveyancing Loan Fees' });
            fields[idx].value.push(ticketsField);
          }
        } else if (getFieldName(ticketsField.name, 1) === 'Real Estate Property') {
          if (_.findIndex(fields, { name: 'Deal - Real Estate Property' }) === -1) {
            fields.push({
              name: getFieldFullName(ticketsField.name),
              level: 0,
              weight: 'e21',
              icon: 'domain',
              isOpen: false,
              workflowType: ['realestate'],
              value: [ticketsField]
            });
          } else {
            const idx = _.findIndex(fields, { name: 'Deal - Real Estate Property' });
            fields[idx].value.push(ticketsField);
          }
        } else if (getFieldName(ticketsField.name, 1) === 'Real Estate Title') {
          if (_.findIndex(fields, { name: 'Deal - Real Estate Title' }) === -1) {
            fields.push({
              name: getFieldFullName(ticketsField.name),
              level: 0,
              weight: 'e22',
              icon: 'title',
              isOpen: false,
              workflowType: ['realestate'],
              value: [ticketsField]
            });
          } else {
            const idx = _.findIndex(fields, { name: 'Deal - Real Estate Title' });
            fields[idx].value.push(ticketsField);
          }
        } else if (getFieldName(ticketsField.name, 1) === 'Real Estate Fees') {
          if (_.findIndex(fields, { name: 'Deal - Real Estate Fees' }) === -1) {
            fields.push({
              name: getFieldFullName(ticketsField.name),
              level: 0,
              weight: 'e23',
              icon: 'monetization_on',
              isOpen: false,
              workflowType: ['realestate'],
              value: [ticketsField]
            });
          } else {
            const idx = _.findIndex(fields, { name: 'Deal - Real Estate Fees' });
            fields[idx].value.push(ticketsField);
          }
        } else if (getFieldName(ticketsField.name, 1) === 'Personal Expenses') {
          if (_.findIndex(fields, { name: 'Deal - Personal Expenses' }) === -1) {
            fields.push({
              name: getFieldFullName(ticketsField.name),
              level: 0,
              weight: 'e24',
              icon: 'shopping_cart',
              isOpen: false,
              workflowType: [
                'assetfinance',
                'commercialloan',
                'conveyancing',
                'homeloan',
                'insurance',
                'personalloan'
              ],
              value: [ticketsField]
            });
          } else {
            const idx = _.findIndex(fields, { name: 'Deal - Personal Expenses' });
            fields[idx].value.push(ticketsField);
          }
        } else if (getFieldName(ticketsField.name, 1) === 'Transportation Expenses') {
          if (_.findIndex(fields, { name: 'Deal - Transportation Expenses' }) === -1) {
            fields.push({
              name: getFieldFullName(ticketsField.name),
              level: 0,
              weight: 'e24',
              icon: 'shopping_cart',
              isOpen: false,
              workflowType: [
                'assetfinance',
                'commercialloan',
                'conveyancing',
                'homeloan',
                'insurance',
                'personalloan'
              ],
              value: [ticketsField]
            });
          } else {
            const idx = _.findIndex(fields, { name: 'Deal - Transportation Expenses' });
            fields[idx].value.push(ticketsField);
          }
        } else if (getFieldName(ticketsField.name, 1) === 'Property Expenses') {
          if (_.findIndex(fields, { name: 'Deal - Property Expenses' }) === -1) {
            fields.push({
              name: getFieldFullName(ticketsField.name),
              level: 0,
              weight: 'e24',
              icon: 'shopping_cart',
              isOpen: false,
              workflowType: [
                'assetfinance',
                'commercialloan',
                'conveyancing',
                'homeloan',
                'insurance',
                'personalloan'
              ],
              value: [ticketsField]
            });
          } else {
            const idx = _.findIndex(fields, { name: 'Deal - Property Expenses' });
            fields[idx].value.push(ticketsField);
          }
        } else if (getFieldName(ticketsField.name, 1) === 'Total Expenses') {
          if (_.findIndex(fields, { name: 'Deal - Total Expenses' }) === -1) {
            fields.push({
              name: getFieldFullName(ticketsField.name),
              level: 0,
              weight: 'e24',
              icon: 'shopping_cart',
              isOpen: false,
              workflowType: [
                'assetfinance',
                'commercialloan',
                'conveyancing',
                'homeloan',
                'insurance',
                'personalloan'
              ],
              value: [ticketsField]
            });
          } else {
            const idx = _.findIndex(fields, { name: 'Deal - Total Expenses' });
            fields[idx].value.push(ticketsField);
          }
        } else if (getFieldName(ticketsField.name, 1) === 'Assets') {
          if (_.findIndex(fields, { name: 'Deal - Assets' }) === -1) {
            fields.push({
              name: getFieldFullName(ticketsField.name),
              level: 0,
              weight: 'e25',
              icon: 'add_circle',
              isOpen: false,
              workflowType: [
                'assetfinance',
                'commercialloan',
                'conveyancing',
                'homeloan',
                'insurance',
                'personalloan'
              ],
              value: [ticketsField]
            });
          } else {
            const title = getFieldName(ticketsField.name, 2);
            const titles = title.split(' ');
            if (
              helperService.getOrganizationCountry().cca2 === 'NZ' &&
              titles[0] === 'KiwiSaver'
            ) {
              const idx = _.findIndex(fields, { name: 'Deal - Assets' });
              fields[idx].value.push(ticketsField);
            } else if (titles[0] !== 'KiwiSaver') {
              const idx = _.findIndex(fields, { name: 'Deal - Assets' });
              fields[idx].value.push(ticketsField);
            }
          }
        } else if (getFieldName(ticketsField.name, 1) === 'Liabilities') {
          if (_.findIndex(fields, { name: 'Deal - Liabilities' }) === -1) {
            fields.push({
              name: getFieldFullName(ticketsField.name),
              level: 0,
              weight: 'e26',
              icon: 'remove_circle',
              isOpen: false,
              workflowType: [
                'assetfinance',
                'commercialloan',
                'conveyancing',
                'homeloan',
                'insurance',
                'personalloan'
              ],
              value: [ticketsField]
            });
          } else {
            const title = getFieldName(ticketsField.name, 2);
            const titles = title.split(' ');
            if (
              helperService.getOrganizationCountry().cca2 === 'NZ' &&
              (titles[0] === 'Overdraft' || title === 'Total Overdraft Limit')
            ) {
              const idx = _.findIndex(fields, { name: 'Deal - Liabilities' });
              fields[idx].value.push(ticketsField);
            } else if (
              helperService.getOrganizationCountry().cca2 === 'AU' &&
              (titles[0] === 'SMSF' || title === 'Total SMSF Loan Repayment Monthly')
            ) {
              const idx = _.findIndex(fields, { name: 'Deal - Liabilities' });
              fields[idx].value.push(ticketsField);
            } else if (
              (helperService.getOrganizationCountry().cca2 === 'AU' &&
                titles[0] !== 'Overdraft' &&
                title !== 'Total Overdraft Limit') ||
              (helperService.getOrganizationCountry().cca2 === 'NZ' &&
                titles[0] !== 'SMSF' &&
                title !== 'Total SMSF Loan Repayment Monthly')
            ) {
              const idx = _.findIndex(fields, { name: 'Deal - Liabilities' });
              fields[idx].value.push(ticketsField);
            }
          }
        } else if (getFieldName(ticketsField.name, 1) === 'Objectives') {
          if (_.findIndex(fields, { name: 'Deal - Objectives' }) === -1) {
            fields.push({
              name: getFieldFullName(ticketsField.name),
              level: 0,
              weight: 'e27',
              icon: 'list',
              isOpen: false,
              workflowType: [
                'assetfinance',
                'commercialloan',
                'conveyancing',
                'homeloan',
                'insurance',
                'personalloan'
              ],
              value: [ticketsField]
            });
          } else {
            const orgCca2 = helperService.getOrganizationCountry().cca2;
            if (
              orgCca2 === 'NZ' &&
              (getFieldName(ticketsField.name, 2) ===
                'Your Health Has Applicant 1 been smoking in the last 12 months?' ||
                getFieldName(ticketsField.name, 2) ===
                  'Your Health Has Applicant 2 been smoking in the last 12 months?' ||
                getFieldName(ticketsField.name, 2) ===
                  'Your Health Has Applicant 3 been smoking in the last 12 months?' ||
                getFieldName(ticketsField.name, 2) ===
                  'Your Health Has Applicant 4 been smoking in the last 12 months?' ||
                getFieldName(ticketsField.name, 2) ===
                  'Are you guaranteeing a loan for any other person?' ||
                getFieldName(ticketsField.name, 2) ===
                  'Your comments why you guaranteeing a loan for any other person')
            ) {
              const idx = _.findIndex(fields, { name: 'Deal - Objectives' });
              fields[idx].value.push(ticketsField);
            } else if (
              getFieldName(ticketsField.name, 2) !==
                'Your Health Has Applicant 1 been smoking in the last 12 months?' &&
              getFieldName(ticketsField.name, 2) !==
                'Your Health Has Applicant 2 been smoking in the last 12 months?' &&
              getFieldName(ticketsField.name, 2) !==
                'Your Health Has Applicant 3 been smoking in the last 12 months?' &&
              getFieldName(ticketsField.name, 2) !==
                'Your Health Has Applicant 4 been smoking in the last 12 months?' &&
              getFieldName(ticketsField.name, 2) !==
                'Are you guaranteeing a loan for any other person?' &&
              getFieldName(ticketsField.name, 2) !==
                'Your comments why you guaranteeing a loan for any other person'
            ) {
              const idx = _.findIndex(fields, { name: 'Deal - Objectives' });
              fields[idx].value.push(ticketsField);
            }
          }
        } else if (getFieldName(ticketsField.name, 1) === 'Insurances') {
          if (_.findIndex(fields, { name: 'Deal - Insurances' }) === -1) {
            fields.push({
              name: getFieldFullName(ticketsField.name),
              level: 0,
              weight: 'e28',
              icon: 'beenhere',
              isOpen: false,
              workflowType: [
                'assetfinance',
                'commercialloan',
                'conveyancing',
                'homeloan',
                'insurance',
                'personalloan'
              ],
              value: [ticketsField]
            });
          } else {
            const idx = _.findIndex(fields, { name: 'Deal - Insurances' });
            fields[idx].value.push(ticketsField);
          }
        } else if (getFieldName(ticketsField.name, 1) === 'Other Advisers') {
          if (_.findIndex(fields, { name: 'Deal - Other Advisers' }) === -1) {
            fields.push({
              name: getFieldFullName(ticketsField.name),
              level: 0,
              weight: 'e29',
              icon: 'people',
              isOpen: false,
              workflowType: [
                'assetfinance',
                'commercialloan',
                'conveyancing',
                'homeloan',
                'insurance',
                'personalloan'
              ],
              value: [ticketsField]
            });
          } else {
            const idx = _.findIndex(fields, { name: 'Deal - Other Advisers' });
            fields[idx].value.push(ticketsField);
          }
        } else if (getFieldName(ticketsField.name, 1) === 'Partners') {
          if (_.findIndex(fields, { name: 'Deal - Partners' }) === -1) {
            fields.push({
              name: getFieldFullName(ticketsField.name),
              level: 0,
              weight: 'e30',
              icon: 'business_center',
              isOpen: false,
              value: [ticketsField]
            });
          } else {
            const idx = _.findIndex(fields, { name: 'Deal - Partners' });
            fields[idx].value.push(ticketsField);
          }
        } else if (getFieldName(ticketsField.name, 1) === 'Tables' && showMultipleData) {
          if (_.findIndex(fields, { name: 'Deal - Tables' }) === -1) {
            fields.push({
              name: getFieldFullName(ticketsField.name),
              level: 0,
              weight: 'e31',
              icon: 'table_chart',
              isOpen: false,
              workflowType: [
                'assetfinance',
                'commercialloan',
                'conveyancing',
                'homeloan',
                'insurance',
                'personalloan'
              ],
              value: [ticketsField]
            });
          } else {
            const orgCca2 = helperService.getOrganizationCountry().cca2;
            if (orgCca2 === 'NZ' && getFieldName(ticketsField.name, 2) === 'Your Health') {
              const idx = _.findIndex(fields, { name: 'Deal - Tables' });
              fields[idx].value.push(ticketsField);
            } else if (getFieldName(ticketsField.name, 2) !== 'Your Health') {
              const idx = _.findIndex(fields, { name: 'Deal - Tables' });
              fields[idx].value.push(ticketsField);
            }
          }
        }
      }

      const homeLoanFields = _.filter(data[0], (d) => d?.groupName === 'HOMELOAN');
      const hLLen = homeLoanFields.length;
      for (let l = 0; l < hLLen; l += 1) {
        const homeLoanField = homeLoanFields[l];
        if (getFieldName(homeLoanField.name, 1) === 'Tables' && showMultipleData) {
          if (_.findIndex(fields, { name: 'Broker Tools - Tables' }) === -1) {
            if (
              homeLoanField.name === 'Broker Tools - Tables - Needs Analysis Risk' ||
              homeLoanField.name === 'Broker Tools - Tables - Needs Analysis Goal'
            ) {
              if ($rootScope.canSeeNeedsAnalysis()) {
                fields.push({
                  name: getFieldFullName(homeLoanField.name),
                  level: 0,
                  weight: 'f01',
                  icon: 'table_chart',
                  isOpen: false,
                  value: [homeLoanField]
                });
              }
            } else {
              fields.push({
                name: getFieldFullName(homeLoanField.name),
                level: 0,
                weight: 'f01',
                icon: 'table_chart',
                isOpen: false,
                value: [homeLoanField]
              });
            }
          } else {
            const idx = _.findIndex(fields, { name: 'Broker Tools - Tables' });
            if (
              homeLoanField.name === 'Broker Tools - Tables - Needs Analysis Risk' ||
              homeLoanField.name === 'Broker Tools - Tables - Needs Analysis Goal'
            ) {
              if ($rootScope.canSeeNeedsAnalysis()) {
                fields[idx].value.push(homeLoanField);
              }
            } else {
              fields[idx].value.push(homeLoanField);
            }
          }
        } else if (
          $rootScope.isAstuteOrg() &&
          getFieldName(homeLoanField.name, 1) === 'Documents' &&
          showMultipleData
        ) {
          if (_.findIndex(fields, { name: 'Broker Tools - Documents' }) === -1) {
            if (homeLoanField.name === 'Broker Tools - Documents - Risk Benefit') {
              if ($rootScope.canSeeNeedsAnalysis() || $rootScope.isIOutsourceOrg()) {
                fields.push({
                  name: getFieldFullName(homeLoanField.name),
                  level: 0,
                  weight: 'f02',
                  icon: 'insert_drive_file',
                  isOpen: false,
                  value: [homeLoanField]
                });
              }
            } else {
              fields.push({
                name: getFieldFullName(homeLoanField.name),
                level: 0,
                weight: 'f02',
                icon: 'insert_drive_file',
                isOpen: false,
                value: [homeLoanField]
              });
            }
          } else {
            const idx = _.findIndex(fields, { name: 'Broker Tools - Documents' });
            if (homeLoanField.name === 'Broker Tools - Documents - Risk Benefit') {
              if ($rootScope.canSeeNeedsAnalysis() || $rootScope.isIOutsourceOrg()) {
                fields[idx].value.push(homeLoanField);
              }
            } else {
              fields[idx].value.push(homeLoanField);
            }
          }
        } else if (getFieldName(homeLoanField.name, 1) === 'Charts' && showMultipleData) {
          if (_.findIndex(fields, { name: 'Broker Tools - Charts' }) === -1) {
            fields.push({
              name: getFieldFullName(homeLoanField.name),
              level: 0,
              weight: 'f03',
              icon: 'insert_chart',
              isOpen: false,
              value: [homeLoanField]
            });
          } else {
            const idx = _.findIndex(fields, { name: 'Broker Tools - Charts' });
            fields[idx].value.push(homeLoanField);
          }
        } else if (getFieldName(homeLoanField.name, 1) === 'Security Details') {
          if (_.findIndex(fields, { name: 'Broker Tools - Security Details' }) === -1) {
            fields.push({
              name: getFieldFullName(homeLoanField.name),
              level: 0,
              weight: 'f04',
              icon: 'account_balance',
              isOpen: false,
              value: [homeLoanField]
            });
          } else {
            const idx = _.findIndex(fields, { name: 'Broker Tools - Security Details' });
            fields[idx].value.push(homeLoanField);
          }
        } else if (getFieldName(homeLoanField.name, 1) === 'Recommended Product') {
          if (_.findIndex(fields, { name: 'Broker Tools - Recommended Product' }) === -1) {
            fields.push({
              name: getFieldFullName(homeLoanField.name),
              level: 0,
              weight: 'f05',
              icon: 'assignment_turned_in',
              isOpen: false,
              value: [homeLoanField]
            });
          } else {
            const idx = _.findIndex(fields, { name: 'Broker Tools - Recommended Product' });
            fields[idx].value.push(homeLoanField);
          }
        } else if (getFieldName(homeLoanField.name, 1) === 'Funding Worksheet') {
          if (_.findIndex(fields, { name: 'Broker Tools - Funding Worksheet' }) === -1) {
            fields.push({
              name: getFieldFullName(homeLoanField.name),
              level: 0,
              weight: 'f06',
              icon: 'monetization_on',
              isOpen: false,
              value: [homeLoanField]
            });
          } else {
            const idx = _.findIndex(fields, { name: 'Broker Tools - Funding Worksheet' });
            fields[idx].value.push(homeLoanField);
          }
        } else if (getFieldName(homeLoanField.name, 1) === 'Fees and Charges') {
          if (_.findIndex(fields, { name: 'Broker Tools - Fees and Charges' }) === -1) {
            fields.push({
              name: getFieldFullName(homeLoanField.name),
              level: 0,
              weight: 'f07',
              icon: 'monetization_on',
              isOpen: false,
              value: [homeLoanField]
            });
          } else {
            const idx = _.findIndex(fields, { name: 'Broker Tools - Fees and Charges' });
            fields[idx].value.push(homeLoanField);
          }
        } else if (getFieldName(homeLoanField.name, 1) === 'Advice Comments') {
          if (_.findIndex(fields, { name: 'Broker Tools - Advice Comments' }) === -1) {
            fields.push({
              name: getFieldFullName(homeLoanField.name),
              level: 0,
              weight: 'f08',
              icon: 'comment',
              isOpen: false,
              value: [homeLoanField]
            });
          } else {
            const idx = _.findIndex(fields, { name: 'Broker Tools - Advice Comments' });
            fields[idx].value.push(homeLoanField);
          }
        } else if (getFieldName(homeLoanField.name, 1) === 'Monthly Financial Position') {
          if (
            _.findIndex(fields, { name: 'Broker Tools - Monthly Financial Position' }) === -1
          ) {
            fields.push({
              name: getFieldFullName(homeLoanField.name),
              level: 0,
              weight: 'f08',
              icon: 'monetization_on',
              isOpen: false,
              value: [homeLoanField]
            });
          } else {
            const idx = _.findIndex(fields, {
              name: 'Broker Tools - Monthly Financial Position'
            });
            fields[idx].value.push(homeLoanField);
          }
        } else if (
          helperService.getOrganizationCountry().cca2 === 'NZ' &&
          getFieldName(homeLoanField.name, 1) === 'Verifications completed'
        ) {
          if (_.findIndex(fields, { name: 'Broker Tools - Verifications completed' }) === -1) {
            fields.push({
              name: getFieldFullName(homeLoanField.name),
              level: 0,
              weight: 'f09',
              icon: 'security',
              isOpen: false,
              value: [homeLoanField]
            });
          } else {
            const idx = _.findIndex(fields, {
              name: 'Broker Tools - Verifications completed'
            });
            fields[idx].value.push(homeLoanField);
          }
        } else if (getFieldName(homeLoanField.name, 1) === 'Broker disclosure') {
          if (_.findIndex(fields, { name: 'Broker Tools - Broker disclosure' }) === -1) {
            fields.push({
              name: getFieldFullName(homeLoanField.name),
              level: 0,
              weight: 'f10',
              icon: 'help',
              isOpen: false,
              value: [homeLoanField]
            });
          } else {
            const orgCca2 = helperService.getOrganizationCountry().cca2;
            if (
              orgCca2 === 'NZ' &&
              (getFieldName(homeLoanField.name, 2) === 'Capitalisation of fees' ||
                getFieldName(homeLoanField.name, 2) === 'Capitalisation of fees comments')
            ) {
              const idx = _.findIndex(fields, {
                name: 'Broker Tools - Broker disclosure'
              });
              fields[idx].value.push(homeLoanField);
            } else if (
              getFieldName(homeLoanField.name, 2) !== 'Capitalisation of fees' &&
              getFieldName(homeLoanField.name, 2) !== 'Capitalisation of fees comments'
            ) {
              const idx = _.findIndex(fields, {
                name: 'Broker Tools - Broker disclosure'
              });
              fields[idx].value.push(homeLoanField);
            }
          }
        } else if (getFieldName(homeLoanField.name, 1) === 'Interest Disclosure') {
          if (_.findIndex(fields, { name: 'Broker Tools - Interest Disclosure' }) === -1) {
            fields.push({
              name: getFieldFullName(homeLoanField.name),
              level: 0,
              weight: 'f10',
              icon: 'turned_in',
              isOpen: false,
              value: [homeLoanField]
            });
          } else {
            const idx = _.findIndex(fields, {
              name: 'Broker Tools - Interest Disclosure'
            });
            fields[idx].value.push(homeLoanField);
          }
        } else if (getFieldName(homeLoanField.name, 1) === 'Product Suitability') {
          if (_.findIndex(fields, { name: 'Broker Tools - Product Suitability' }) === -1) {
            fields.push({
              name: getFieldFullName(homeLoanField.name),
              level: 0,
              weight: 'f11',
              icon: 'verified_user',
              isOpen: false,
              value: [homeLoanField]
            });
          } else {
            const idx = _.findIndex(fields, {
              name: 'Broker Tools - Product Suitability'
            });
            fields[idx].value.push(homeLoanField);
          }
        }
      }

      if ($rootScope.canSeeAssetFinanceTools()) {
        const assetFinanceMergeFields = _.filter(
          data[0],
          (d) => d?.groupName === 'ASSET FINANCE'
        );
        const aFLen = assetFinanceMergeFields.length;
        for (let a = 0; a < aFLen; a += 1) {
          const assetFinanceMergeField = assetFinanceMergeFields[a];
          if (getFieldName(assetFinanceMergeField.name, 1) === 'Tables' && showMultipleData) {
            if (_.findIndex(fields, { name: 'Asset finance tools - Tables' }) === -1) {
              fields.push({
                name: getFieldFullName(assetFinanceMergeField.name),
                level: 0,
                weight: 'g01',
                icon: 'table_chart',
                isOpen: false,
                value: [assetFinanceMergeField]
              });
            } else {
              const isNlgOrPtf = $rootScope.isDev() || $rootScope.isNlg();
              if (
                isNlgOrPtf &&
                getFieldName(assetFinanceMergeField.name, 2) ===
                  'NLG Finance proposal associated fees'
              ) {
                const idx = _.findIndex(fields, { name: 'Asset finance tools - Tables' });
                fields[idx].value.push(assetFinanceMergeField);
              } else if (
                getFieldName(assetFinanceMergeField.name, 2) !==
                'NLG Finance proposal associated fees'
              ) {
                const idx = _.findIndex(fields, { name: 'Asset finance tools - Tables' });
                fields[idx].value.push(assetFinanceMergeField);
              }
            }
          }
          if (getFieldName(assetFinanceMergeField.name, 1) === 'Charts' && showMultipleData) {
            if (_.findIndex(fields, { name: 'Asset finance tools - Charts' }) === -1) {
              fields.push({
                name: getFieldFullName(assetFinanceMergeField.name),
                level: 0,
                weight: 'g02',
                icon: 'insert_chart',
                isOpen: false,
                value: [assetFinanceMergeField]
              });
            } else {
              const idx = _.findIndex(fields, { name: 'Asset finance tools - Charts' });
              fields[idx].value.push(assetFinanceMergeField);
            }
          }
          if (getFieldName(assetFinanceMergeField.name, 1) === 'Asset to be financed') {
            if (
              _.findIndex(fields, {
                name: 'Asset finance tools - Asset to be financed'
              }) === -1
            ) {
              fields.push({
                name: getFieldFullName(assetFinanceMergeField.name),
                level: 0,
                weight: 'g03',
                icon: 'directions_car',
                isOpen: false,
                value: [assetFinanceMergeField]
              });
            } else {
              const idx = _.findIndex(fields, {
                name: 'Asset finance tools - Asset to be financed'
              });
              fields[idx].value.push(assetFinanceMergeField);
            }
          }
          if (getFieldName(assetFinanceMergeField.name, 1) === 'Finance proposal') {
            if (
              _.findIndex(fields, { name: 'Asset finance tools - Finance proposal' }) === -1
            ) {
              fields.push({
                name: getFieldFullName(assetFinanceMergeField.name),
                level: 0,
                weight: 'g04',
                icon: 'monetization_on',
                isOpen: false,
                value: [assetFinanceMergeField]
              });
            } else {
              const idx = _.findIndex(fields, {
                name: 'Asset finance tools - Finance proposal'
              });
              fields[idx].value.push(assetFinanceMergeField);
            }
          }
          if (getFieldName(assetFinanceMergeField.name, 1) === 'Compliance') {
            if (_.findIndex(fields, { name: 'Asset finance tools - Compliance' }) === -1) {
              fields.push({
                name: getFieldFullName(assetFinanceMergeField.name),
                level: 0,
                weight: 'g05',
                icon: 'comment',
                isOpen: false,
                value: [assetFinanceMergeField]
              });
            } else {
              const idx = _.findIndex(fields, {
                name: 'Asset finance tools - Compliance'
              });
              fields[idx].value.push(assetFinanceMergeField);
            }
          }
          if (
            helperService.getOrganizationCountry().cca2 === 'NZ' &&
            getFieldName(assetFinanceMergeField.name, 1) === 'Verifications completed'
          ) {
            if (
              _.findIndex(fields, { name: 'Asset finance tools - Verifications completed' }) ===
              -1
            ) {
              fields.push({
                name: getFieldFullName(assetFinanceMergeField.name),
                level: 0,
                weight: 'g06',
                icon: 'security',
                isOpen: false,
                value: [assetFinanceMergeField]
              });
            } else {
              const idx = _.findIndex(fields, {
                name: 'Asset finance tools - Verifications completed'
              });
              fields[idx].value.push(assetFinanceMergeField);
            }
          }
          if (
            getFieldName(assetFinanceMergeField.name, 1) ===
            'Basis for recommendations made and customer disclosures'
          ) {
            if (
              _.findIndex(fields, {
                name: 'Asset finance tools - Basis for recommendations made and customer disclosures'
              }) === -1
            ) {
              fields.push({
                name: getFieldFullName(assetFinanceMergeField.name),
                level: 0,
                weight: 'g07',
                icon: 'help',
                isOpen: false,
                value: [assetFinanceMergeField]
              });
            } else {
              const idx = _.findIndex(fields, {
                name: 'Asset finance tools - Basis for recommendations made and customer disclosures'
              });
              fields[idx].value.push(assetFinanceMergeField);
            }
          }
          if (getFieldName(assetFinanceMergeField.name, 1) === 'Interest disclosure') {
            if (
              _.findIndex(fields, { name: 'Asset finance tools - Interest disclosure' }) === -1
            ) {
              fields.push({
                name: getFieldFullName(assetFinanceMergeField.name),
                level: 0,
                weight: 'g08',
                icon: 'turned_in',
                isOpen: false,
                value: [assetFinanceMergeField]
              });
            } else {
              const idx = _.findIndex(fields, {
                name: 'Asset finance tools - Interest disclosure'
              });
              fields[idx].value.push(assetFinanceMergeField);
            }
          }
          if (getFieldName(assetFinanceMergeField.name, 1) === 'Product suitability') {
            if (
              _.findIndex(fields, { name: 'Asset finance tools - Product suitability' }) === -1
            ) {
              fields.push({
                name: getFieldFullName(assetFinanceMergeField.name),
                level: 0,
                weight: 'g09',
                icon: 'verified_user',
                isOpen: false,
                value: [assetFinanceMergeField]
              });
            } else {
              const idx = _.findIndex(fields, {
                name: 'Asset finance tools - Product suitability'
              });
              fields[idx].value.push(assetFinanceMergeField);
            }
          }
          if (getFieldName(assetFinanceMergeField.name, 1) === 'Recommended product') {
            if (
              _.findIndex(fields, { name: 'Asset finance tools - Recommended product' }) === -1
            ) {
              fields.push({
                name: getFieldFullName(assetFinanceMergeField.name),
                level: 0,
                weight: 'g10',
                icon: 'work',
                isOpen: false,
                value: [assetFinanceMergeField]
              });
            } else {
              const idx = _.findIndex(fields, {
                name: 'Asset finance tools - Recommended product'
              });
              fields[idx].value.push(assetFinanceMergeField);
            }
          }
        }
      }

      const toolsFields = _.filter(data[0], (d) => d?.groupName === 'BROKER_TOOLS');
      const hLTLen = toolsFields.length;
      for (let l = 0; l < hLTLen; l += 1) {
        const toolsField = toolsFields[l];
        if (getFieldName(toolsField.name, 1) === 'BID indicators') {
          if (_.findIndex(fields, { name: 'Broker tools - BID indicators' }) === -1) {
            fields.push({
              name: getFieldFullName(toolsField.name),
              level: 0,
              weight: 'h01',
              icon: 'speed',
              isOpen: false,
              value: [toolsField]
            });
          } else {
            const idx = _.findIndex(fields, { name: 'Broker tools - BID indicators' });
            fields[idx].value.push(toolsField);
          }
        }
      }

      const workflowsFields = _.filter(data[0], (d) => d?.groupName === 'WORKFLOW');
      const wLen = workflowsFields.length;
      for (let w = 0; w < wLen; w += 1) {
        const workflowsField = workflowsFields[w];
        if (getFieldName(workflowsField.name, 1) === 'General Information') {
          if (_.findIndex(fields, { name: 'Workflow - General Information' }) === -1) {
            fields.push({
              name: getFieldFullName(workflowsField.name),
              level: 0,
              weight: 'k01',
              icon: 'label',
              isOpen: true,
              value: [workflowsField]
            });
          } else {
            const idx = _.findIndex(fields, { name: 'Workflow - General Information' });
            fields[idx].value.push(workflowsField);
          }
        } else if (getFieldName(workflowsField.name, 1) === 'Stage') {
          if (_.findIndex(fields, { name: 'Workflow - Stage' }) === -1) {
            fields.push({
              name: getFieldFullName(workflowsField.name),
              level: 0,
              weight: 'k02',
              icon: 'view_week',
              isOpen: false,
              value: [workflowsField]
            });
          } else {
            const idx = _.findIndex(fields, { name: 'Workflow - Stage' });
            fields[idx].value.push(workflowsField);
          }
        }
      }

      const organizationsFields = _.filter(data[0], (d) => d?.groupName === 'ORGANIZATION');
      const oLen = organizationsFields.length;
      for (let o = 0; o < oLen; o += 1) {
        const organizationsField = organizationsFields[o];
        if (getFieldName(organizationsField.name, 1) === 'General Information') {
          if (_.findIndex(fields, { name: 'Organization - General Information' }) === -1) {
            fields.push({
              name: getFieldFullName(organizationsField.name),
              level: 0,
              weight: 'j01',
              icon: 'domain',
              isOpen: false,
              value: [organizationsField]
            });
          } else {
            const idx = _.findIndex(fields, { name: 'Organization - General Information' });
            fields[idx].value.push(organizationsField);
          }
        }
      }

      if (data[1].length) {
        const cf = [];
        const cfLen = data[1]?.length;
        let count = 1;
        for (let f = 0; f < cfLen; f += 1) {
          const key = data[1][f].name.capitalizeFirstLetter().replace(/\W/g, '');
          cf.push({
            name: `Deal - Custom Fields - ${data[1][f].name}`,
            key: `deal.customField${key}${count}`,
            type: data[1][f].type === 'money' ? 'currency' : data[1][f].type,
            width: '0 0 20em',
            weight: '15a'
          });
          count += 1;
        }
        fields.push({
          name: 'Deal - Custom Fields',
          level: 0,
          weight: 'e33',
          icon: 'input',
          isOpen: false,
          value: cf
        });
      }
      deferred.resolve(fields);
    });
    return deferred.promise;
  };

  /**
   * Get grouped merge fields.
   *
   * @returns {Array}
   */
  const getMarketingFields = () => {
    const deferred = $q.defer();
    const fields = [];
    getAvailableMergeKeys({ model: 'contact' }).then((data) => {
      const contactsFields = _.filter(data, (d) => d?.groupName === 'CONTACT');
      const cLen = contactsFields.length;
      for (let c = 0; c < cLen; c += 1) {
        const contactsField = contactsFields[c];
        if (getFieldName(contactsField.name, 0) === 'Contacts') {
          if (getFieldName(contactsField.name, 1) === 'Group Data') {
            if (_.findIndex(fields, { name: 'Contacts - Group Data' }) === -1) {
              fields.push({
                name: getFieldFullName(contactsField.name),
                level: 0,
                weight: 'a01',
                icon: 'group',
                isOpen: true,
                value: [contactsField]
              });
            } else {
              const idx = _.findIndex(fields, { name: 'Contacts - Group Data' });
              fields[idx].value.push(contactsField);
            }
          }
        } else if (getFieldName(contactsField.name, 0) === 'Contact 1') {
          if (getFieldName(contactsField.name, 1) === 'General Information') {
            if (_.findIndex(fields, { name: 'Contact 1 - General Information' }) === -1) {
              fields.push({
                name: getFieldFullName(contactsField.name),
                level: 0,
                weight: '1a',
                icon: 'account_circle',
                isOpen: true,
                value: [contactsField]
              });
            } else {
              const idx = _.findIndex(fields, { name: 'Contact 1 - General Information' });
              fields[idx].value.push(contactsField);
            }
          } else if (getFieldName(contactsField.name, 1) === 'Basic Contact Information') {
            if (_.findIndex(fields, { name: 'Contact 1 - Basic Contact Information' }) === -1) {
              fields.push({
                name: getFieldFullName(contactsField.name),
                level: 0,
                weight: '2a',
                icon: 'phone',
                isOpen: true,
                value: [contactsField]
              });
            } else {
              const idx = _.findIndex(fields, {
                name: 'Contact 1 - Basic Contact Information'
              });
              fields[idx].value.push(contactsField);
            }
          }
        }
        deferred.resolve(fields);
      }
    });
    return deferred.promise;
  };

  return {
    getFieldName,
    getFieldFullName,
    getFields,
    getMarketingFields
  };
};
